import React from "react";
import { SvgIcon, SvgIconProps } from "@mui/material";
const AppIconsQuery = React.forwardRef((props: SvgIconProps, ref: any) => {
  return (
    <SvgIcon {...props} ref={ref}>
      <g fill="currentColor">
        <circle cx="12.2777777" cy="17.7808781" r="1.0604067" />
        <path
          d="M12.2777786,1.1111112c-6.0351553,0-10.9444456,4.9092903-10.9444456,10.9444447S6.2426233,23,12.2777786,23
		s10.9444427-4.9092903,10.9444427-10.9444437S18.3129311,1.1111112,12.2777786,1.1111112z M12.2777786,21.490118
		c-5.2016664,0-9.4345655-4.2328987-9.4345655-9.4345646s4.2328992-9.4345655,9.4345655-9.4345655
		s9.4345646,4.2328987,9.4345646,9.4345655v0.0000019C21.7123432,17.2572193,17.4794426,21.490118,12.2777786,21.490118z"
        />
        <path
          d="M12.2777815,5.640749h-0.0000029c-0.9665842,0-1.8917131,0.3578334-2.6030159,1.0080414
		C8.9656429,7.2924528,8.5227165,8.1717606,8.42453,9.1187086c-0.0196362,0.196372,0.0414572,0.386198,0.1723719,0.5345678
		l0.004364,0.004364c0.1374598,0.1505508,0.3360128,0.2356453,0.5389309,0.2356453H9.177289
		c0.3796511,0,0.7047558-0.2945576,0.757122-0.6873007c0.1505508-1.1738653,1.1607752-2.0597205,2.3455505-2.0597205
		c1.302597,0,2.3630047,1.0604072,2.3630047,2.3651872c0,0.6327534-0.2465553,1.2284136-0.6938467,1.6735229
		c-0.0676384,0.0676384-0.181098,0.1592789-0.3011026,0.2552834l-0.0283642,0.0218191
		c-0.3534698,0.2858295-0.8356705,0.6763916-1.2502327,1.2502327c-0.4931107,0.6807547-0.7745771,1.474968-0.8356695,2.3542776
		v0.0021811c-0.0130911,0.196372,0.0545473,0.3840151,0.185462,0.5280218l0.004364,0.004364
		c0.1374598,0.1461887,0.3316498,0.2291002,0.5323858,0.2291002h0.0370922c0.3861961,0,0.7156649-0.3076477,0.748394-0.7025738
		c0.1134596-1.3462372,0.929492-2.0095358,1.5273342-2.4917383l0.0218191-0.0196371
		c0.1570978-0.1265507,0.2989216-0.2421913,0.4211082-0.36656c0.7309389-0.7331219,1.1324091-1.7062511,1.1324091-2.7404757
		c0-1.0320415-0.4036522-2.0051718-1.1345901-2.7382932C14.2851353,6.0422206,13.314187,5.640749,12.2777815,5.640749z"
        />
      </g>
    </SvgIcon>
  );
});

export default AppIconsQuery;
